<template>
    <div class="cropper-container">
        <b-button-toolbar style="background-color: white;">
            <b-button-group size="sm">
                <b-button title="Sola Döndür" @click="rotateLeft" variant="outline-success">
                    <b-icon icon="arrow-counterclockwise"/>
                </b-button>
                <b-button class="mr-1" title="Sağa Döndür" @click="rotateRight" variant="outline-success">
                    <b-icon icon="arrow-clockwise"/>
                </b-button>
                <b-button title="Yakınlaştır" @click="changeScale(8)" variant="outline-success">
                    <b-icon icon="plus"/>
                </b-button>
                <b-button title="Uzaklaştır" @click="changeScale(-8)" variant="outline-success">
                    <b-icon icon="dash"/>
                </b-button>
                
                <b-button v-if="!crap" @click="startCrop" variant="outline-primary">İşaretlemeye Başla</b-button>
                <b-button v-else @click="stopCrop" variant="outline-primary">İşaretlemeyi Durdur</b-button>
                
                
                <b-button @click="clearCrop" variant="outline-primary">Temizle</b-button>
                <b-button id="yenileBtn" @click="refreshCrop" variant="outline-primary">Yenile</b-button>
                <b-button @click="fullEkran()" variant="outline-success">
                    <b-icon icon="arrows-fullscreen"  />
                </b-button>
            </b-button-group>
        </b-button-toolbar>

        <b-spinner v-show="isLoading"/>

        <vueCropper
                ref="cropper"
                :img="img"
                :outputSize="option.size"
                :outputType="option.outputType"
                :info="true"
                :autoCrop="option.autoCrop"
                :autoCropWidth="option.autoCropWidth"
                :autoCropHeight="option.autoCropHeight"
                :high="option.high"
                :mode="option.mode"
                @cropMoving="cropMoving"
                @imgLoad="imgLoad"
        />

        <b-modal ref="kesmeBilgiModal"
                 cancel-title="İptal Et"
                 ok-title="Gönder"
                 @ok="sendCropDetails()"
                 @cancel="iptalEt()"
                 title="Kelimeyi Sor">
            <div style="overflow: scroll">
                <img alt="" :src="this.cropDetails.resim"/>
            </div>

            <b-form-textarea
                    v-model="aciklama"
                    placeholder="Açıklama"
                    rows="2"
            />
        </b-modal>
    </div>
</template>

<script>
    import moment from 'moment'
    import {VueCropper} from "vue-cropper"

    export default {
        name: "cropper",
        props: ['img'],
        data() {
            return {
                angle: 0,
                crap: false,
                aciklama: '',
                cropDetails: {
                    resim: '',
                    canvas: {
                        trueWidth: 0,
                        trueHeight: 0,
                        x1: 0,
                        y1: 0,
                        framew: 0,
                        frameh: 0,
                        scale: 0,
                    }
                },
                option: {
                    size: 1,
                    outputType: "png",
                    autoCrop: false,
                    autoCropWidth: 150,
                    autoCropHeight: 150,
                    high: false,
                    cropData: {},
                    mode: 'cover',
                },
                isLoading: true
            }
        },
        methods: {
            iptalEt() {
                this.$refs.cropper.clearCrop();
            },
            fullEkran() {
                window.open(
                    this.img,
                    '_blank'
                );
            },
            imgLoad(msg) {
                this.isLoading = false;
                if (msg === "success") {
                    this.$refs.cropper.y += Math.abs(this.$refs.cropper.getImgAxis().y1)
                }
            },
            sendCropDetails() {
                this.$refs.cropper.clearCrop();
                this.$emit('sendCropDetails', this.aciklama, this.cropDetails.canvas)
                this.aciklama = ''
            },
            startCrop() {
                this.crap = true;
                this.$refs.cropper.startCrop();
            },
            stopCrop() {
                this.$refs.cropper.$data.crop = false
                this.crap = false;

                const imgAxis = this.$refs.cropper.getImgAxis()
                const cropAxis = this.$refs.cropper.getCropAxis()

                this.cropDetails.canvas = {
                    trueWidth: this.$refs.cropper.trueWidth,
                    trueHeight: this.$refs.cropper.trueHeight,
                    x1: cropAxis.x1 - imgAxis.x1,
                    y1: cropAxis.y1 - imgAxis.y1,
                    framew: this.$refs.cropper.cropW,
                    frameh: this.$refs.cropper.cropH,
                    scale: this.$refs.cropper.scale.toFixed(5),
                    angle: this.angle
                };

                this.$refs.cropper.getCropData(base64img => {
                    this.cropDetails.resim = base64img;
                    this.$refs.kesmeBilgiModal.show();
                });
            },
            clearCrop() {
                this.$refs.cropper.clearCrop();
            },
            refreshCrop() {
                this.$refs.cropper.refresh();
                this.angle = 0;
            },
            changeScale(num) {
                num = num || 1;
                this.$refs.cropper.changeScale(num);
            },
            rotateLeft() {
                this.$refs.cropper.rotateLeft();
                this.angle += 90
            },
            rotateRight() {
                this.$refs.cropper.rotateRight();
                this.angle -= 90
            },
            cropMoving(data) {
                this.option.cropData = data;
            }
        },
        mounted() {

        },
        components: {
            VueCropper
        }
    }
</script>

<style scoped lang="scss">
    .cropper-container {
        height: calc(100% - 32px);
    }

    #yenileBtn {
        @media (max-width: 700px) {
            display: none;
        }
    }
</style>
